<i18n src="../../locales/lang.json"></i18n>

<template>
  <div style="display: inline; position: relative; z-index: 100000">
    <div style="position:absolute;" class="speech-bubble-tooltip" v-bind:class="getClass()" v-bind:id="getId()" v-if="this.currentstep == this.step">
      <div class="container-fluid">
        <span style="position: absolute; right: 20px; top: 10px; z-index: 10;"><a href="#" @click="doDone" style="color:inherit"><i class="icon-cross2"></i></a></span>
        <div class="row mb-1" v-if="displayTitle != null">
          <div class="col"><button v-if="nr != null" type="button" class="btn btn-outline-secondary btn-icon rounded-pill border-2 mr-2">{{nr}}</button><span>{{displayTitle}}</span></div>
        </div>
        <div class="row">
          <div class="col" style="font-size:20px;"><button v-if="nr != null && title == null" type="button" class="btn btn-outline-secondary btn-icon rounded-pill border-2 mr-2">{{nr}}</button>{{getContent()}}</div>
        </div>
        <div class="row mt-1" v-if="next == 'true'">
          <div class="col text-right" style="font-size:20px;"><span>{{$t('next')}}</span><button type="button" class="btn btn-outline-secondary btn-icon rounded-pill border-2 ml-2" @click.stop="doNext"><i class="icon-arrow-right5"></i></button></div>
        </div>
        <div class="row mt-1" v-if="end == 'true'">
          <div class="col text-right" style="font-size:20px;"><span>{{$t('done')}}</span><button type="button" class="btn btn-outline-secondary btn-icon rounded-pill border-2 ml-2" @click.stop="doDone"><i class="icon-checkmark2 icon-2x"></i></button></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
    name: 'help-left',
		components: {
    },
    props: {
      id: {
        required: false,
        type: String,
        default:null
      },
      nr: {
        required: false,
        type: String,
        default: null
      },
      title: {
        required: false,
        type: String,
        default: null
      },
      step: {
        required: false,
        type: String,
        default: "-1"
      },
      text: {
        required: false,
        type: String,
        default: "some_text"
      },
      translate: {
        required: false,
        type: String,
        default: "some_text"
      },
      next: {
        required: false,
        type: String,
        default: "false"
      },
      end: {
        required: false,
        type: String,
        default: "false"
      },
      
    },
    data() {
      return {
        animation: " hidden",
        currentstep: "",
        displayTitle: '',
        displayBody: ''
      };
    },
    methods: {
      doDone() {
       
        this.$root.$emit("endhelp");
        this.hide();
      },
      doNext() {
        this.$root.$emit("help", parseInt(this.step) + 1);
      },
      getContent() {
        /*
        if (this.translate == null || typeof (this.translate) == "undefined") {
          return this.$t(translate);
        }
        return this.text;*/
        this.displayBody = this.$store.translate(this.text);
        if (this.displayBody == null)
          this.displayBody = this.title;
        return this.displayBody;
      },
      getId() {
        if (this.id == null || typeof (this.id) == "undefined") {
          this.id = 'image_' + this._uid;
          return 'image_' + this._uid;
        }
        return this.id;
      },
      getClass() {
        return this.animation;
      },
      show(step) {
        this.currentstep = step.toString();
        if (step == parseInt(this.step)) {
          this.animation = " animated fadeIn";
        }
        else
          this.hide()
        
      },
      hide() {
        this.animation = " hidden fadeOut";
      },
    },
    created() {
      
    },
    mounted() {
      this.$root.$on('help', this.show);

      this.displayTitle = this.$store.translate(this.title);
      if (this.displayTitle == null)
        this.displayTitle = this.title;

      var thisContext = this;

      this.$root.$on('endhelp', function () { thisContext.hide() });
    }
}
</script>

<style scoped>
  .btn-outline-secondary {
    color: #6a6969;
  }

    .btn-outline-secondary:hover {
      color: #F7F7F7;
      background-color: #6a6969;
      border-color: #6a6969;
    }

  .hidden {
    opacity: 0;
  }

  .speech-bubble-tooltip {
    background: #F7F7F7;
    border-radius: .4em;
    padding-top: 15px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 15px;
    font-size: 24px;
    color: #6a6969;
    float: left;
    top: 34px;
    left: -45px;
    min-width: 300px;
    z-index: 100000
  }

    .speech-bubble-tooltip:after {
      content: '';
      position: absolute;
      top: 0;
      left: 45px;
      width: 0;
      height: 0;
      border: 20px solid transparent;
      border-bottom-color: #F7F7F7;
      border-top: 0;
      margin-left: -20px;
      margin-top: -20px;
      z-index: 100000
    }
</style>



// WEBPACK FOOTER //
// src/components/general/help-left.vue